// PROTOTYPE (hero shapes): AVRAH's ball, painted on Costellazione's canvas
// (DiscTransitions.jsx): drawn, not lit, so it sits among the clients' flat
// dots as part of one drawing. A flat disc in the gold button's gold at rest
// (--gold, ../../tokens.css), and a crescent in its pressed gold
// (--gold-pressed) on the side away from the light, which comes from the top
// right, as the logo's does.

// The light's direction, x right and y down the screen.
const LIGHT = [Math.cos(-Math.PI / 3), Math.sin(-Math.PI / 3)];
// How deep the crescent is, as a share of the radius.
const SHADE = 0.24;

const circle = (ctx, x, y, r) => {
  ctx.beginPath();
  ctx.arc(x, y, r, 0, 2 * Math.PI);
};

// The ball `ball` ({ x, y, r }, in the canvas's pixels) in `golds` ({ rest,
// shade }, as CSS colours); nothing while it has no size. The crescent is
// what of the ball lies outside a circle as big, its middle SHADE of the
// radius toward the light.
export function paintBall(ctx, ball, golds) {
  const { x, y, r } = ball;
  if (!(r > 0)) return;
  circle(ctx, x, y, r);
  ctx.fillStyle = golds.rest;
  ctx.fill();
  ctx.save();
  circle(ctx, x, y, r);
  ctx.clip();
  ctx.beginPath();
  ctx.rect(x - 2 * r, y - 2 * r, 4 * r, 4 * r);
  ctx.arc(x + LIGHT[0] * SHADE * r, y + LIGHT[1] * SHADE * r, r, 0, 2 * Math.PI, true);
  ctx.fillStyle = golds.shade;
  ctx.fill("evenodd");
  ctx.restore();
}
